import { render, staticRenderFns } from "./PlatformProfile.vue?vue&type=template&id=687170b8&"
import script from "./PlatformProfile.vue?vue&type=script&lang=js&"
export * from "./PlatformProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports